const defaultState = {
  requesting: false,
  error: false,
  result: null,
  isCreate: false,
  isDelete: false,
  loaded: false
}

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'CREATE_DIMENSION_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null,
        isCreate: true,
        isDelete: false,
        loaded: false
      }
    case 'CREATE_DIMENSION_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload,
        isCreate: true,
        isDelete: false,
        loaded: true
      }
    case 'CREATE_DIMENSION_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload,
        isCreate: true,
        isDelete: false,
        loaded: false
      }
    case 'UPDATE_DIMENSION_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null,
        isCreate: true,
        isDelete: false,
        loaded: false
      }
    case 'UPDATE_DIMENSION_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload,
        isCreate: true,
        isDelete: false,
        loaded: true
      }
    case 'UPDATE_DIMENSION_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload,
        isCreate: true,
        isDelete: false,
        loaded: false
      }
    case 'DELETE_DIMENSION_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null,
        isCreate: false,
        isDelete: true,
        loaded: false
      }
    case 'DELETE_DIMENSION_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload,
        isCreate: false,
        isDelete: true,
        loaded: true
      }
    case 'DELETE_DIMENSION_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload,
        isCreate: false,
        isDelete: true,
        loaded: false
      }
    default:
      return state
  }
}
